import { Typography } from 'components'
import { PolarAngleAxis, RadialBar, RadialBarChart, ResponsiveContainer } from 'recharts'

import * as S from './styles'

interface GoalGraphProps {
  percentValue: number
}

export const GoalGraph: React.FC<GoalGraphProps> = ({ percentValue }) => {
  const getFillColor = (value: number) => {
    if (value < 50) return '#FF4842'
    if (value >= 50 && value < 85) return '#FF8D23'
    if (value >= 85 && value < 100) return '#FFC107'
    return '#54D62C'
  }

  const formatValue = (value: number) => {
    return Number(value.toFixed(1))
  }

  return (
    <S.GraphWrapper>
      <S.GraphOverlay>
        <ResponsiveContainer>
          <RadialBarChart
            data={[{ fill: getFillColor(percentValue), value: percentValue }]}
            endAngle={-55}
            innerRadius={'85%'}
            outerRadius={'135%'}
            startAngle={235}
          >
            <PolarAngleAxis domain={[0, 100]} tick={false} type="number" />
            <RadialBar background cornerRadius={5} dataKey="value" />
          </RadialBarChart>
        </ResponsiveContainer>
      </S.GraphOverlay>
      <S.TextOverlay>
        <Typography className="display-value" design="hav-h5-text">
          {formatValue(percentValue)}%
        </Typography>
        <Typography design="hav-default-04-text">da meta</Typography>
      </S.TextOverlay>
    </S.GraphWrapper>
  )
}
